module.exports = __webpack_public_path__ + "media/images/official/special_workcation_07-e2fb0e26c05fc5c36884495d71ee053e.jpg";